<template>
  <div class="app">
    <div class='app-container'>
      <div class='top-nav'>
        <div class='top-nav-width-limit'>
          <div class='nav-logo' v-scroll-to="'#main-slide'">
            <div class='rentdream-logo-img'>
              <img src='@/assets/rentdream-logo-black.png' alt='title'>
            </div>
          </div>
          <div class="top-nav-list">
            <ul>
              <li><a href='/' v-scroll-to="'#cars'">보유차량</a></li>
              <li><a href='/' v-scroll-to="'#rent-normal'">일반렌트</a></li>
              <li><a href='/' v-scroll-to="'#rent-accident'">사고대차</a></li>
              <li><a href='/' v-scroll-to="'#rent-brodcast'">방송/촬영협찬</a></li>
              <li><a href='/' v-scroll-to="'#rent-vip'">VIP의전</a></li>
            </ul>
        </div>
      </div>
    </div>
    <div class='dummy-top-nav'></div>
      <main-slide id='main-slide' :window='window'></main-slide>
      <cars id='cars' :window='window'></cars>
      <rent-normal id='rent-normal' :window='window'></rent-normal>
      <rent-accident id='rent-accident' :window='window'></rent-accident>
      <rent-brodcast id='rent-brodcast' :window='window'></rent-brodcast>
      <rent-vip id='rent-vip' :window='window'></rent-vip>

          <div class='footer'>
              <div class='footer-content'>
              <div class='nav-logo'>
                <div>
                  <img src='@/assets/rentdream-logo-white.png' alt='title'>
                </div>
              </div>
              <div class='footer-info'>
                <div>
                  <ul>
                    <li>상호 : (주)렌트드림네트웍스</li>
                    <li>사업자등록번호 : 450-81-00922</li>
                    <li>주소 : 서울시 강남구 봉은사로 507, 16층</li>
                  </ul>
                </div>
              </div>
              <div class='footer-info'>
                <div>
                  <ul>
                    <li>대표번호 : 1600-2240</li>
                    <li>연락처 : 010-8422-8224, 010-3900-2300</li>
                    <li>이메일 : help@rentdream.co.kr</li>
                  </ul>
                </div>
              </div>
              <div class='footer-info'>
                <div>
                  <ul>
                    <br>
                    <li>Copyright (c) 2016 rentdream All Rights Reserved</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <fixed-bottom></fixed-bottom>
    </div>

  </div>
</template>

<script>
  import MainSlide from './components/MainSlide.vue'
  import Cars from './components/Cars.vue'
  import RentNormal from './components/RentNormal.vue'
  import RentAccident from './components/RentAccident.vue'
  import RentBrodcast from './components/RentBrodcast.vue'
  import RentVip from './components/RentVip.vue'
  import FixedBottom from './components/FixedBottom.vue'

  export default {
    name: 'app',
    components: {
      MainSlide,
      Cars,
      RentNormal,
      RentAccident,
      RentBrodcast,
      RentVip,
      FixedBottom,
    },
    data () {
      return {
        window: {
          width: 0,
          height: 0,
        }
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      }
    }
  }
</script>

<style>
  @font-face {
    font-family: s-core1;
    src: url(assets/S-Core_Dream_OTF/SCDream1.otf);
  }
  @font-face {
    font-family: s-core2;
    src: url(assets/S-Core_Dream_OTF/SCDream2.otf);
  }
  @font-face {
    font-family: s-core3;
    src: url(assets/S-Core_Dream_OTF/SCDream3.otf);
  }
  @font-face {
    font-family: s-core3;
    src: url(assets/S-Core_Dream_OTF/SCDream3.otf);
  }
  @font-face {
    font-family: s-core4;
    src: url(assets/S-Core_Dream_OTF/SCDream4.otf);
  }
  @font-face {
    font-family: s-core5;
    src: url(assets/S-Core_Dream_OTF/SCDream5.otf);
  }
  @font-face {
    font-family: s-core6;
    src: url(assets/S-Core_Dream_OTF/SCDream6.otf);
  }
  @font-face {
    font-family: s-core7;
    src: url(assets/S-Core_Dream_OTF/SCDream7.otf);
  }
  @font-face {
    font-family: s-core8;
    src: url(assets/S-Core_Dream_OTF/SCDream8.otf);
  }

  @font-face {
    font-family: s-core9;
    src: url(assets/S-Core_Dream_OTF/SCDream9.otf);
  }
  html{
    font-size: 16px;
  }
  body {
    margin: 0;
  }

  .app {
    font-family: s-core5;
  }

  .section {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    background: #ffffff;
  }
  .section-title-underline {
    width: 10em;
    border: 2px solid #000000;
  }

  .section-title {
    font-family: s-core7;
  }

  .section-title h1{
    font-size: 4em;
    margin-top: 0.97em;
    margin-bottom: 0em;
  }
  .section-title-description {
    margin-top: 3.56em;
  }
  .section-title-description h2{
    text-align: center;
    font-size: 3em;
    margin: 0px;
    font-family: s-core7;
  }

  .section-title-description p {
    text-align: center;
    font-size: 1.6em;
    margin: 0;
  }
  /* media */
  @media (max-width: 1264px){
    html{
      font-size:13px;
    }
  }
  @media (max-width: 1100px){
    html{
      font-size:12px;
    }
  }
  /* mobile */
  @media (max-width: 710px){
    html{
      font-size: 6px;
    }
  }

</style>

<style scoped>
  /* top nav */
  .top-nav {
    background-color: #ffffff;
    position: fixed;
    padding: 2em;
    z-index: 2;
    left: 0;
    right: 0;
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .top-nav-width-limit {
    width: 1420px;
    display: flex;
    justify-content: space-between;
  }

  .top-nav-list {
    flex: 0.9;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 2px;
  }
  .top-nav-list ul {
    margin: 0;
    display: flex;
    justify-content: space-between;
  }
  .top-nav-list li {
    padding: 1em 1em 0 1em;
    list-style: none;
  }
  .top-nav-list a{
    font-size: 1.6em;
    text-decoration: none;
    color: #000000;
  }
  .dummy-top-nav {
    width: 100%;
    height: 7em;
  }
  /* footer */
  .footer {
    width: 100%;
    height: 30em;
    background: #000000;
    padding: 3em 0;
  }
  .footer-content {
    max-width: 1420px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    font-family: s-core2;
  }
  .footer-info {
    color: #ffffff;
  }
  .footer-info ul {
    list-style: none;
  }


      /* media */
      @media (max-width: 1264px){
        .top-nav-list {
          flex: 1;
        }
        .nav-logo img {
          width: 150px;
        }
      }
      @media (max-width: 1100px){
        .top-nav-list {
          flex: 1;
        }
        .nav-logo img {
          width: 100px;
        }
        .top-nav-list li {
          padding: 0;
          list-style: none;
        }
      }
      /* mobile */
      @media (max-width: 710px){
        .top-nav-list {
          flex: 1;
        }
        .nav-logo img {
          width: 70px;
        }
        .top-nav-list li {
          padding: 0;
          list-style: none;
        }
      }


</style>
